import React from "react";

import { I18n } from "aws-amplify";

import { Task } from "../../utils/task";
import { FormUtils } from "../../utils/form";

import TextAreaField from "../form/textarea-field";

import RadioMultiField from "../form/radio-multi-field";

import constants from "../../constants";

import { scrollToTop } from "../../utils/ui";

import { CustomEventBriefingType } from "../../model";

import { Textarea } from "../../v2/components/UI/Textarea";

const evt = CustomEventBriefingType.Event;
const shp = CustomEventBriefingType.Shopper;
const ict = CustomEventBriefingType.Incentive;
const dgt = CustomEventBriefingType.Digital;
const com = CustomEventBriefingType.Communication;

class AudienceForm extends React.Component {
  constructor(props) {
    super();

    const customEvent = props.customEvent || {};

    this.state = {
      fields: {
        audience: {
          label: I18n.get("Qual é o público?"),
          onChange: this.onChangeFormNew.bind(this, "audience"),
          onBlur: this.onSave.bind(this),
          successIcon: false,
        },
        eventSize: {
          labels: {
            [evt]: I18n.get("Para quantas pessoas será o evento?"),
            [shp]: I18n.get("Quantas pessoas pretendem que sejam impactadas?"),
            [ict]: I18n.get("Quantas pessoas pretendem que sejam impactadas?"),
            [dgt]: I18n.get("Para quantas pessoas será o evento?"),
            [com]: I18n.get("Para quantas pessoas será o evento?"),
          },
          onChange: this.onChangeFormNew.bind(this, "eventSize"),
          // onBlur: this.onSave.bind(this),
          successIcon: false,
        },
        requiresInvitation: {
          labels: {
            [evt]: I18n.get("Como os participantes serão convidados?"),
            [shp]: I18n.get("Pensaram em algum tipo de convite ou “chamada”?"),
            [ict]: I18n.get("Pensaram em algum tipo de convite ou “chamada”?"),
            [dgt]: I18n.get("Como os participantes serão convidados?"),
            [com]: I18n.get("Como os participantes serão convidados?"),
          },
          onChange: this.onChangeForm.bind(this, "requiresInvitation"),
          // onBlur: this.onSave.bind(this),
          values: constants.EVENT_INVITATIONS,
          successIcon: false,
        },
        invitationChannel: {
          label: I18n.get("Quais os canais a serem trabalhados?"),
          onChange: this.onChangeFormNew.bind(this, "invitationChannel"),
          // onBlur: this.onSave.bind(this),
          successIcon: false,
        },
      },
      errors: {},
      form: { ...customEvent },
      task: {},
      submit_task: {},
    };
  }

  componentDidMount() {
    scrollToTop();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const task = this.props.task || {};
    const prev = (prevProps && prevProps.task) || {};

    //console.dir({ task: task, prev: prev });

    if (task != prev) {
      var nextState = Object.assign({}, prevState, { task: task });

      const customEvent = this.props.customEvent || {};

      Object.keys(this.state.form).forEach((item) => {
        if (item in this.state.fields) {
          return; // local state is king
        }

        nextState.form[item] = customEvent[item];
      });

      this.setState(nextState);
    }
  }

  componentWillUnmount() {
    this.props.update_custom_event(this.getData());
  }

  onChangeForm(prop, e) {
    const value = e.target.value;

    this.setState(
      (prevState) => {
        var nextState = Object.assign({}, prevState);

        nextState.form[prop] = value;
        nextState.errors[prop] = null;

        return nextState;
      },
      () => this.onSaving()
    );
  }

  onChangeFormNew(prop, e) {
    const value = e;

    this.setState(
      (prevState) => {
        var nextState = Object.assign({}, prevState);

        nextState.form[prop] = value;
        nextState.errors[prop] = null;

        return nextState;
      },
      () => this.onSaving()
    );
  }

  getData() {
    var data = {
      projectId: this.props.match.params.projectId,
      ...this.props.customEvent,
      ...this.state.form,
    };

    return data;
  }

  onSaving() {
    clearTimeout(this.t);
    this.t = setTimeout(() => this.onSave(), 1000);
  }

  onSave() {
    var submit_task = new Task();

    submit_task.start();

    this.setState({ submit_task: submit_task });

    this.props.update_custom_event(this.getData()).then(({ task, errors }) => {
      this.setState({ submit_task: task, errors: errors });
    });
  }

  render() {
    const customEvent = this.props.customEvent || {};

    return (
      <div>
        <h1 className="title-bpool medium">{I18n.get("Público")}</h1>

        <div className="bp-event-section">
          {/* <TextAreaField
                        {...this.state.fields.audience}
                        value={this.state.form.audience}
                        error={this.state.errors.audience} /> */}

          <Textarea
            label={this.state.fields.audience.label}
            defaultValue={this.state.form.audience}
            value={this.state.form.audience}
            onChange={(value) => this.state?.fields?.audience.onChange(value)}
            error={this.state?.errors?.audience?.errorMessage}
          />

          <br />

          {/* <TextAreaField
                        {...this.state.fields.eventSize}
                        labelKey={customEvent.briefingType}
                        value={this.state.form.eventSize}
                        error={this.state.errors.eventSize} /> */}

          <Textarea
            label={this.state.fields.eventSize.labels[customEvent.briefingType]}
            defaultValue={this.state.form.eventSize}
            value={this.state.form.eventSize}
            onChange={(value) => this.state?.fields?.eventSize.onChange(value)}
            error={this.state?.errors?.eventSize?.errorMessage}
          />

          <br />

          <RadioMultiField
            {...this.state.fields.requiresInvitation}
            labelKey={customEvent.briefingType}
            value={this.state.form.requiresInvitation}
            error={this.state.errors.requiresInvitation}
          />

          {(customEvent.isShopper || customEvent.isIncentive) && (
            <>
              <br />

              {/* <TextAreaField
                        {...this.state.fields.invitationChannel}
                        value={this.state.form.invitationChannel}
                        error={this.state.errors.invitationChannel} /> */}

              <Textarea
                label={this.state.fields.invitationChannel.label}
                defaultValue={this.state.form.invitationChannel}
                value={this.state.form.invitationChannel}
                onChange={(value) =>
                  this.state?.fields?.invitationChannel.onChange(value)
                }
                error={this.state?.errors?.invitationChannel?.errorMessage}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}

export default AudienceForm;
